//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getview } from '@/api/jfhl.js'
import config from '@/config/index'
export default {
  components: {},
  data () {
    return {
      baseUrl: config.baseUrl,
      partyid: this.$route.params.partyid,
      banner: '',
      explist: []
    }
  },
  watch: {},
  mounted () {
    this.view()
  },
  methods: {
    // 获取问卷id
    view () {
      getview({
        id: this.partyid
      }).then(res => {
        document.title = res.obj.title
        this.banner = res.obj.hdpicList.length > 0 && this.baseUrl + res.obj.hdpicList[0].FILEPATH
        this.explist = res.obj.explist
      })
    }
  },
  created () { }
}
